// Connected MultiDayTrendDialog for opening from the map's polygon
// (crop-select) pressure logger selection. Mirrors the wiring used by
// PressureSensorsTable, but takes the sensor list via ownProps.sensorIds
// and opens directly on the trend overlay tab.
import { connect } from 'react-redux';

import * as actionsPressure from '../../actions/SensorsPressureActions';
import MultiDayTrendDialog from '../../components/SensorsTabs/Pressure/MultiDayTrendDialog';

const mapStateToProps = (state, ownProps) => {
  const selectedProject = state.leaksList.selectedProject;
  const projectData = state.leaksList.leaksByProject[selectedProject];
  return {
    pressureUnit: state.local.pressureUnit || 'meter',
    projectId: selectedProject,
    lastPressureSample: projectData?.sensors?.pressureSensors?.samples?.[0],
    timeZone: state.local.timeZone,
    projectTimezone: projectData?.projectDetails?.time_zone,
    transientThresholds: state.leaksList.pressure?.transientThresholds || { med: 20, high: 30 },
    pressureSensors: projectData?.sensors?.pressureSensors?.items || [],
    sensorId: ownProps.sensorIds[0],
    initialSensorIds: ownProps.sensorIds,
    initialTab: 'overlay',
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchMultiDayReading: (projectId, loggerId, startDate, endDate) =>
    dispatch(actionsPressure.fetchMultiDayReading(projectId, loggerId, startDate, endDate)),
  fetchMultiDayTransients: (projectId, loggerId, startDate, endDate) =>
    dispatch(actionsPressure.fetchMultiDayTransients(projectId, loggerId, startDate, endDate)),
  fetchPressureAlarmsForSensor: (projectId, loggerId) =>
    dispatch(actionsPressure.fetchPressureAlarmsForSensor(projectId, loggerId)),
  fetchTransientReading: (projectId, sensorId, readingId) =>
    dispatch(actionsPressure.fetchPressureTransientReading(projectId, sensorId, readingId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MultiDayTrendDialog);
